import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import React from "react";
import { connect } from "react-redux";
import { editMarker } from "../../actions";
import { availableLanguageMappings } from "../../settings";
import _ from "lodash";

const QuestionTabTextField = (props) => {
  // console.log(props)
  return (
    <Grid container alignItems="flex-end">
      <Grid item xs={4}>
        <Box m={1}>
          <Select
          fullWidth
          disabled={props.disabled}
          onChange={props.onChange}
          defaultValue={props.defaultValue}
          value={props.value}
          >
            {_.map(availableLanguageMappings, (val, key) => (
              <MenuItem value={val}>{key}</MenuItem>
            ))}
          </Select>
        </Box>
      </Grid>
      <Grid item xs={8}>
        <Box m={1}>
          <TextField
            fullWidth
            onChange={props.onTextChange}
            rowsMax={5}
            multiline
            value={props.textValue}
            label={props.label || "Question/Challenge"}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default connect(null, { editMarker })(QuestionTabTextField);
